import { Chip as MuiChip } from '@mui/material'
import { RxCross2 } from 'react-icons/rx'
import { tss } from 'tss-react/mui'
import { ChipProps } from '../types'
import { getChipBasePrimitives, getChipColorPrimitives } from './primitives'

/**
 * Renders a chip with a ghost background on hover
 */
export function GhostChip({
  color,
  isRounded = false,
  className,
  noPadding = false,
  ...rest
}: Omit<ChipProps, 'variant'>) {
  const { cx, classes } = useStyles({ color, isRounded, noPadding })

  return (
    <MuiChip
      className={cx(classes.chip, className)}
      deleteIcon={<RxCross2 className="min-h-4 min-w-4" size="16px" />}
      {...rest}
    />
  )
}

const useStyles = tss
  .withParams<Omit<ChipProps, 'variant'>>()
  .create(({ color, isRounded, noPadding, theme }) => {
    const chipBasePrimitives = getChipBasePrimitives('ghost', color, isRounded, noPadding)
    const colorPrimitives = getChipColorPrimitives('ghost', color)

    return {
      chip: {
        ...colorPrimitives,
        ...chipBasePrimitives,
        '&.Mui-disabled': {
          opacity: 1,
          '& .MuiChip-label': {
            color: theme.palette.common.doss.gray[9],
          },
        },
      },
    }
  })
